import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/src/app/local-resources-map/components/LocalResourcesInteractive.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/src/components/common/Header.tsx");
